export const config = {
    'API_KEY': 'AIzaSyCAr4_7aSMmQ4kLnR5cbqnCYbLdPPtw2Hw',
    'CLIENT_ID': '273033434753-laf0qm75cehad2f7p7uuv8ppnvq6753a.apps.googleusercontent.com',
    'OPENWEATHERMAP_API_KEY': '410463b3935acea56c8171825dbb4440',
};